import React from 'react'
import axios from 'axios'
import { useCartContext } from '../context/cart_context'
import { Link } from 'react-router-dom'
import { Layout } from '../components/page-layout'

const CheckoutPage = () => {
  const { cart } = useCartContext()

  const handleCheckout = async () => {
    try {
      const res = await axios.post('http://localhost:5050/api/checkout/create-checkout-session', {
        cartItems: cart,
        // Optionally add customerEmail if you have it
      });
      window.location.href = res.data.url; // Redirect to Stripe Checkout
    } catch (err) {
      alert('Error creating checkout session');
    }
  };

  if (cart.length < 1) {
    return (
      <Layout showCommonFooter={true}>
        <div style={{ textAlign: 'center', marginTop: '2rem' }}>
          <h2>Your cart is empty</h2>
          <Link to='/products' className='btn'>
            Fill your cart
          </Link>
        </div>
      </Layout>
    )
  }

  return (
    <Layout showCommonFooter={true}>
      <div style={{ textAlign: 'center', marginTop: '2rem' }}>
        <h2>Ready to checkout?</h2>
        <button className="btn" onClick={handleCheckout}>
          Go to Secure Payment
        </button>
      </div>
    </Layout>
  );
  }

export default CheckoutPage
